export default __webpack_public_path__ + "f76d64ad09b67d1e476db381e4df29ac.png";